import React from 'react';
import { DeleteProgress } from '../useDuplicateResolver';

/**
 * Shown while copies are being moved. Says where the files are going rather
 * than just "deleting", because that is the part users worry about.
 */
export const DeleteProgressBar: React.FC<{ progress: DeleteProgress }> = ({
  progress,
}) => {
  const percent =
    progress.total > 0
      ? Math.round((progress.completed / progress.total) * 100)
      : 0;

  return (
    <div className="dup-bar dup-bar--progress">
      <p className="dup-bar-summary">
        Moving <span className="dup-num">{progress.completed}</span> of{' '}
        <span className="dup-num">{progress.total}</span> to the Recycle Bin
        {progress.failed > 0 && (
          <span className="dup-bar-failed">
            {' '}
            · <span className="dup-num">{progress.failed}</span> couldn&apos;t
            be moved
          </span>
        )}
      </p>
      <div className="dup-progress-track">
        <div className="dup-progress-fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default DeleteProgressBar;
